{
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "heroTitle": "立即订阅，畅读当日完整电子报及前14天往期存档。",
  "heroSubtitle": "传统排版与现代视图，一键自由切换——你的报纸，以你的方式阅读。",
  "or": "或者",
  "singleCopyTitle": "当日电子报——按次在线购买，无续费压力，享受阅读的自由。",
  "singleCopySubtitle": "",
  "buyToday": "购买当日电子报",
  "publications": {
    "st": "海峡时报",
    "zb": "联合早报",
    "sm": "新明日报",
    "tm": "淡米尔之声",
    "bt": "商业时报",
    "bh": "每日新闻"
  },
  "links": {
    "buyToday": "https://subscribe.sph.com.sg/pages/zh/epaper/buy?utm_campaign=singlecopyepaper&utm_medium=sph-publication&utm_source=epaperlp&utm_content=purchaselink-epaperlp-singlecopy",
    "publications": {
      "st": "https://subscribe.sph.com.sg/zh/publications-st?utm_campaign=st_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-st",
      "zb": "https://subscribe.sph.com.sg/zh/publications-zb?utm_campaign=zb_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-zb",
      "sm": "https://subscribe.sph.com.sg/zh/publications-sm?utm_campaign=sm_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-sm",
      "tm": "https://subscribe.sph.com.sg/zh/publications-tm?utm_campaign=tm_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-tm",
      "bt": "https://subscribe.sph.com.sg/zh/publications-bt?utm_campaign=bt_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-bt",
      "bh": "https://subscribe.sph.com.sg/zh/publications-bh?utm_campaign=bh_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-bh"
    }
  },
  "footer": {
    "about": "关于我们",
    "promotions": "促销",
    "subscriptionTerms": "订阅条款与细则",
    "termsConditions": "条款与细则",
    "cookieNotice": "Cookie 使用声明",
    "personalDataProtection": "个人资料保护声明",
    "officialDomains": "官方域名",
    "contactUs": "联系我们",
    "feedback": "意见反馈",
    "generalEnquiries": "一般类咨询:",
    "corporateEnquiries": "企业咨询:",
    "copyright": "Copyright © {{year}} SPH Media Limited. Co. Regn. No. 202120748H. All Rights Reserved.",
    "address": "1000 Toa Payoh North Annexe Level 6, News Centre Singapore 318994"
  },
  "footerLinks": {
    "promotions": "https://subscribe.sph.com.sg/zh/promotions-listing/",
    "subscriptionTerms": "https://subscribe.sph.com.sg/tnc/standard/",
    "termsConditions": "https://www.sph.com.sg/legal/website_tnc/",
    "cookieNotice": "https://www.sph.com.sg/tnc/cookie/",
    "personalDataProtection": "https://www.sph.com.sg/tnc/pdpa/",
    "officialDomains": "https://www.sph.com.sg/official-domains",
    "onlineForm": "https://subscribe.sph.com.sg/zh/contact-us/"
  }
}
